export const desktopHeaderHeight = 76;
export const mobileHeaderHeight = 56;
export const mobileBottomNavHeight = 56;
